export const SPECS = {
  UseDeliveryOptionsLibInExpress: 'specs.ecom.UseDeliveryOptionsLibInExpress',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  ErrorHandlerOnCheckout: 'specs.ecom.ErrorHandlerOnCheckout',
  UseConvertedPricesInExpress: 'specs.ecom.UseConvertedPricesInExpress',
  FixCarrierIdForSelectShippingOptionExpress: 'specs.ecom.FixCarrierIdForSelectShippingOptionExpress',
  UseExpressCheckoutSettings: 'specs.ecom.UseExpressCheckoutSettings',
  FixAdditionalFeeWithoutCode: 'specs.ecom.FixAdditionalFeeWithoutCode',
  UseAdditionalFeeTranslatedNameExpress: 'specs.ecom.UseAdditionalFeeTranslatedNameExpress'
};
//# sourceMappingURL=SPECS.js.map